import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// hooks

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user, logout } = useAuth();

  const isClient = isAuthenticated && user?.userType === 'client';
  // A non-client session (e.g. admin) must not stay logged in on the client login page
  const shouldLogout = isAuthenticated && !isClient;

  useEffect(() => {
    if (shouldLogout) {
      logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldLogout]);

  if (isClient) {
    return <Navigate to="/client/app" />;
  }

  return <>{children}</>;
}
